import { useEffect, useState } from 'react';
import { isSoftKeyboardOpen } from '../utils/softKeyboardOpen';

function readKeyboardOpen(): boolean {
  if (typeof window === 'undefined') return false;
  const vv = window.visualViewport;
  if (!vv) return false;
  return isSoftKeyboardOpen(window.innerHeight, vv.height);
}

/** Écoute visualViewport (Capacitor iOS/Android + Safari mobile). */
export function useSoftKeyboardOpen(): boolean {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const sync = () => setOpen(readKeyboardOpen());
    sync();

    const vv = window.visualViewport;
    vv?.addEventListener('resize', sync);
    vv?.addEventListener('scroll', sync);
    window.addEventListener('resize', sync);

    return () => {
      vv?.removeEventListener('resize', sync);
      vv?.removeEventListener('scroll', sync);
      window.removeEventListener('resize', sync);
    };
  }, []);

  return open;
}
